import "$src/app.scss";
import Launch from "$src/Launch.svelte";

const page = new Launch({
    target: document.getElementById('app'),
    props: (typeof pageVars !== 'undefined') ? pageVars() : {}
});

export default page
